/*
 * UserList Messages
 *
 * This contains all the text for the UserList component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.DepotEdit.title',
    defaultMessage: 'Edit Depot',
  },
  saveButton: {
    id: 'app.containers.DepotEdit.saveButton',
    defaultMessage: 'Save',
  },
  saveSuccess: {
    id: 'app.containers.DepotEdit.saveSuccess',
    defaultMessage: 'Depot has been successfully updated.',
  },
  saveFailure: {
    id: 'app.containers.DepotEdit.saveFailure',
    defaultMessage: 'Error. The depot could not be updated.',
  },
  deleteButton: {
    id: 'app.containers.DepotEdit.deleteButton',
    defaultMessage: 'Delete',
  },
  deleteSuccess: {
    id: 'app.containers.DepotEdit.deleteSuccess',
    defaultMessage: 'Depot has been successfully deleted.',
  },
  deleteFailure: {
    id: 'app.containers.DepotEdit.deleteFailure',
    defaultMessage: 'Error. The depot could not be deleted.',
  },
  deleteConfirmTitle: {
    id: 'app.containers.DepotEdit.deleteConfirmTitle',
    defaultMessage: 'Delete Depot?',
  },
  deleteConfirmText: {
    id: 'app.containers.DepotEdit.deleteConfirmText',
    defaultMessage: 'Deleting a Depot will permanently remove it.',
  },
  deleteConfirmDelete: {
    id: 'app.containers.DepotEdit.deleteConfirmDelete',
    defaultMessage: 'Yes, Delete Depot',
  },
  deleteConfirmCancel: {
    id: 'app.containers.DepotEdit.deleteConfirmCancel',
    defaultMessage: 'No, Keep Depot',
  },
});
